import { request } from "./request";
import { assetHost } from "./../app";
export const fetchMedia = (options, data = [], admin, context = $("body")) => {
	return new Promise(async (resolve, reject) => {
		if (!admin) {
			try {
				const response = await $.ajax({
					method: "GET",
					url: `${assetHost}/dam_assets.json`
				});

				resolve(response);
			} catch (err) {
				console.error("Error getting DAM assets:", err);
				// error getting cached assets? try alt method
			}
		} else {
			try {
				const params = Object.assign(
					{
						reqId: "90120937-1745-4ed4-90b7-b91687e79ed0"
					},
					options
				);
				const response = await request(params, context);
				data = data.concat(response.items);
				// add assets from this call to assets array
				if (data.length < response.total_count) {
					// if total assets is less than total
					// count value returned from call, we
					// need to make another call
					options.offset = data.length;
					// our offset value is the current length
					// of our assets array
					resolve(fetchMedia(options, data, admin, context));
				} else {
					resolve(data);
				}
			} catch (err) {
				console.error("rejecting error in fetchmedia.js");
				reject(err);
			}
		}
	});
};
